import * as storage from './storage'

export const update = (): void => {
  const container: object = globalThis._CONTAINER_
  const simulation: object = globalThis._SIMULATION_
  const nodes: array = storage.nodes()
  const links: array = storage.links()

  if (simulation !== undefined) {
    simulation.nodes(nodes)
    simulation.force('link').links(links)
  }

  if (links !== undefined) {
    container.selectAll('link')
      .data(links)
      .join(enter => enter.append('link').attr('id', d => d.id))
  }

  if (nodes !== undefined) {
    container.selectAll('node')
      .data(nodes)
      .join(enter => enter.append('node').attr('id', d => d.id))
  }
}
